import { RefObject, useEffect, useRef, useState } from 'react';

const MILESTONES = [25, 50, 75, 100];

function getLastCompletedMilestone(milestones: number[], progress: number) {
  const completed = milestones.filter((milestone) => milestone <= progress);

  return completed.length ? completed[completed.length - 1] : 0;
}

export default function useScrollProgress(containerRef: RefObject<HTMLElement>) {
  const scrollProgress = useRef(0);
  const [currentMilestone, setMilestone] = useState(0);

  useEffect(() => {
    const el = containerRef.current;

    const handleScroll = (): void => {
      if (el) {
        const scrolled = Math.round(((el.scrollTop + el.clientHeight) / el.scrollHeight) * 100);

        if (scrollProgress.current !== scrolled) {
          scrollProgress.current = Math.max(scrolled, scrollProgress.current);
        }

        const lastMilestone = getLastCompletedMilestone(MILESTONES, scrollProgress.current);

        if (lastMilestone > currentMilestone) {
          setMilestone(lastMilestone);
        }
      }
    };

    el?.addEventListener('scroll', handleScroll);

    return () => {
      el?.removeEventListener('scroll', handleScroll);
    };
  }, [currentMilestone, containerRef]);

  return currentMilestone;
}
